// ********************************************************
// Prevent Leave
// This module can be used to handle leave logic.
// This module is a mixin that can extend or "mix in"
// some common logic into a vue compoent
// ********************************************************

export default {
  data: () => ({
    preventLeave: false
  }),
  computed: {
    buttonAppend () {
      if (this.preventLeave) return '*'
      else return ''
    }
  },
  watch: {
    form: {
      handler () {
        // Set preventLeave to true if form has changed after load
        if (!this.loading) this.preventLeave = true
      },
      deep: true
    }
  },
  async beforeRouteLeave (to, from, next) {
    // Ask user regarding leaving (unless we try to leave to login) if preventLeave is true
    if (this.preventLeave && to.name !== 'login') {
      this.preventLeave = false
      next(false)

      const answer = await this.$root.$confirmLeave(to.path)

      if (answer === 'submit') {
        this.redirectTo = to.name
        this.submit()
      }

      if (answer === 'cancel') {
        this.preventLeave = true
      }
    } else next()
  }
}
